import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
} from "@heroui/react";
import { IconDeviceFloppy } from "@tabler/icons-react";
import { useResumeBuilder } from "../context";
import type { LanguageSkill } from "../types";
import { LanguageForm, languageFormId } from "./language-form";

type FormData = LanguageSkill;

interface ExperienceModalProps {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    onFormSubmit: (data: FormData) => void;
}

const LanguageModal = ({
    title,
    isOpen,
    onClose,
    onFormSubmit,
}: ExperienceModalProps) => {
    const { design } = useResumeBuilder();

    return (
        <Modal
            isOpen={isOpen}
            onOpenChange={onClose}
            backdrop="blur"
            size="3xl"
            // fixes: https://github.com/heroui-inc/heroui/issues/3937#issuecomment-2620261488
            placement="center"
            shouldBlockScroll={false}
            disableAnimation={true}
            classNames={{ wrapper: "items-start h-auto", base: "my-auto" }}
        >
            <ModalContent>
                {(close) => (
                    <>
                        <ModalHeader>{title}</ModalHeader>
                        <ModalBody>
                            <LanguageForm
                                isOpen={isOpen}
                                onClose={close}
                                onFormSubmit={onFormSubmit}
                            />
                        </ModalBody>
                        <ModalFooter className="justify-right flex">
                            <Button
                                color="danger"
                                variant="light"
                                onPress={close}
                            >
                                Abbrechen
                            </Button>
                            <Button
                                type="submit"
                                form={languageFormId}
                                style={{
                                    backgroundColor: design.resumePrimaryColor,
                                    color: design.resumePrimaryContrastColor,
                                }}
                                startContent={
                                    <IconDeviceFloppy stroke={1.5} size={20} />
                                }
                            >
                                Speichern
                            </Button>
                        </ModalFooter>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};

export { LanguageModal };
